














import {Component} from "vue-property-decorator";
import {AppContent, Sidebar, Navbar} from "./components";
import {mixins} from "vue-class-component";
import {ResizeMixin} from "@/shared/services/mixin";
import {AppModule} from "@/store/modules/app";
import {DeviceType} from "@/enums/type";

@Component({
    name: 'LayoutCommon',
    components: {Navbar, AppContent, Sidebar},
})
export default class extends mixins(ResizeMixin) {
    private deviceType = DeviceType;

    get device() {
        return AppModule.device;
    }
}
